export function getToken() {
    const elem = document.querySelector('meta[name="csrf-token"]');

    if (elem && elem.content) {
        return elem.content;
    }

    return null;
}

const includeTokenForMethods = ['PATCH', 'POST', 'PUT', 'DELETE'];

export function requestShouldIncludeToken(method) {
    if (typeof method !== 'string') {
        return false;
    }

    return includeTokenForMethods.includes(method.toUpperCase());
}



// WEBPACK FOOTER //
// ./services/csrfTokenService.js